import React from 'react' // eslint-disable-line no-unused-vars
import '../../css/forms/default-forms.css'
import { connect } from 'react-redux'
import { addNotification as notify } from 'reapop'
import CountryAwareComponent from '../CountryAwareComponent'
import { RingLoader } from 'react-spinners'
import { v4 as uuidv4 } from 'uuid'
import { triggerSSO } from '../InitiateSSO'
import { api } from '../index.api'
import Footer from '../Footer'
import { isAbsoluteUrl, isMobileDevice } from '../../functions.js'
import imgProductInfo from './assets/site_resources_product_info.jpeg'
import imgClinicalTrialInfo from './assets/site_resources_clinical_trial_info.jpeg'
import imgDiseaseStateInfo from './assets/site_resources_disease_state_info.jpeg'
import imgMainMobile from './assets/site_resources_header_mobile.jpeg'
import StaticConfig from '../StaticConfig'
import { PATIENT } from '../../constants'
import { Link } from 'react-router-dom'
import { getCookie } from "../../helpers/CookieHandler";

class SiteResources extends CountryAwareComponent {
  constructor (props) {
    super(props)

    const userType = StaticConfig.Context.UserType;
   // let cookieCountryLanguage = getCookie("welcomeLanguage");
    const content = this.props.pageContent.content.module.hcpResources;
    const pageTitle = userType === PATIENT ? content.patientPageTitle : content.hcpPageTitle
    //let pageTitle
    // // if (userType === PATIENT && cookieCountryLanguage === 'de') {
    // //   pageTitle = 'Ressourcen'
    // // } if (userType === PATIENT && cookieCountryLanguage !== "de") {
    // //   pageTitle = 'Resources'
    // // } 
    // // else {
    // //   pageTitle = 'HCP Resources'
    // // }
    this.state = {
      // resourceItems: [],
      searching: false,
      countryName: null,
      mobileSectionsIsExpanded: [false, false, false],
      userType: userType,
      content: content
    }

    this.componentName = 'SiteResources'
    // this.loadSiteResources = this.loadSiteResources.bind(this)
    this.showMessage = false
    this.pageTitle = pageTitle
  }

  // componentDidMount () {
  //   this.loadSiteResources({})
  // }

  // loadSiteResources (postData, callbackFn) {
  //   this.setState({ resourceItems: [] }, function () {
  //     this.forceUpdate()
  //   })

  //   this.showMessage = false
  //   this.setState({ searching: true })
  //   const userType = this.state.userType
  //   api.siteResources(
  //     { userType },
  //     this._searchSuccessHandler.bind(this, postData),
  //     this._searchFailureHandler.bind(this)
  //   )
  // }
// Uncommenting for HCP from here
  // _searchSuccessHandler = (postData, response) => {
  //   if (response.status === 200) {
  //     response.json().then(responseJson => {
  //       const resourceItems = responseJson
  //       if (resourceItems.length === 0) {
  //         this.showMessage = true
  //       }
  //       this.setState({ searching: false })
  //       this.setState({ resourceItems: resourceItems }, function () {
  //         this.forceUpdate()
  //       })
  //     })
  //   } else if (response.status === 401) {
  //     this._showNotification(
  //       'Error',
  //       'You are not authorized to perform this action. Please log in again.',
  //       'error'
  //     )
  //     setTimeout(() => triggerSSO(this.props.pageContent.content.lang), 3000)
  //   } else {
  //     this._showNotification(
  //       'Error',
  //       'Error occurred while submitting query',
  //       'error'
  //     )
  //     this.setState({ searching: false })
  //   }
  // }

  // _searchFailureHandler = error => { /* eslint-disable-line */
  //   this.setState({ searching: false })
  //   this._showNotification('Error', 'Unexpected error occurred!', 'error')
  // }

  setSearchAuditId = searchAuditId => {
    this.setState({ searchAuditId })
  }

  _showNotification = (title, message, status) => {
    const { notify } = this.props
    notify({
      title,
      message,
      status,
      position: 'tr',
      dismissible: true,
      dismissAfter: 3000
    })
  }

  toggleSection = sectionIndex => {
    this.setState({
      mobileSectionsIsExpanded: this.state.mobileSectionsIsExpanded.map((expandedState, index) => {
        return (index === sectionIndex) ? !expandedState : expandedState
      })
    })
  }

  renderSection = (sectionIndex, sectionTitle, sectionImg, items) => {
    return (
      <div
        style={{
          border: isMobileDevice() ? "" : "1px solid #666",
          borderRadius: isMobileDevice() ? "" : "12px",
          paddingBottom: isMobileDevice() ? "" : "24px",
        }}
      >
        {isMobileDevice() ? (
          <table style={{ width: "100%", border: "0px solid red" }}>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "#071D49",
                      padding: "10px 10px 10px 10px",
                    }}
                  >
                    {sectionTitle}
                  </div>
                </td>
                <td
                  style={{
                    paddingRight: "14px",
                    width: "50px",
                    border: "0px solid blue",
                  }}
                >
                  <span
                    style={{
                      color: "#071D49",
                      fontSize: "40px",
                      padding: "5px 0px 0px 5px",
                      fontWeight: "900",
                    }}
                    className={`fa ${
                      this.state.mobileSectionsIsExpanded[sectionIndex]
                        ? "fa-angle-up"
                        : "fa-angle-down"
                    } fa-lg`}
                    onClick={() => this.toggleSection(sectionIndex)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <div
            key={`key${uuidv4()}`}
            style={{
              backgroundImage: `url(${sectionImg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100.5%",
              height: "222px",
              textAlign: "center",
              color: "white",
              fontSize: "28px",
              fontWeight: "bold",
              marginLeft: "0px",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            }}
          >
            <div
              style={{
                background: "rgba(17, 42, 65, 0.60)",
                mixBlendMode: "normal",
                width: "100%",
                height: "100%",
                paddingTop: "65px",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
              }}
            >
              <div>{sectionTitle}</div>
            </div>
          </div>
        )}
        {!isMobileDevice() ? <div>&nbsp;</div> : null}
        {items.map((item) => (
          <div
            style={{
              display: !isMobileDevice()
                ? ""
                : this.state.mobileSectionsIsExpanded[sectionIndex]
                ? ""
                : "none",
            }}
            key={`key${uuidv4()}`}
          >
            <div
              style={{
                padding: isMobileDevice()
                  ? "10px 10px 10px 10px"
                  : "10px 20px 10px 20px",
                fontSize: "16px",
                width: "100%",
              }}
            >
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{fontWeight: "bold"}}>
                      {isAbsoluteUrl(item.url) ? (
                        <a 
                          href={`${item.url}`}
                          target= {item.target}
                          rel="noopener noreferrer"
                          data-tag="track-exit"
                          data-analytics-text={`Resources: ${item.title}`}
                          onClick={(event) => {
                            const msg =
                              "By clicking this link, you will be taken away from abbviemedinfo.com";
                              if (item.showPopup){
                                if (window.confirm(msg)) {
                                  return true;
                                }
                                event.stopPropagation();
                                event.preventDefault();
                                return false;
                              }
                            }}
                        >
                          <span
                            style={{
                              color: "#222222",
                              fontWeight: "bold",
                              wordBreak: "break-word",
                              borderBottom: "1px solid #2f9ece",
                            }}
                          >
                            {`${item.title}`}
                          </span>
                        </a>
                      ) : item.url.startsWith('/') ? (<Link
                        to={item.url}
                        className='anchor-link'
                        data-tag='track-link'
                        data-analytics-text='Browse'
                      >{item.title}</Link>) : (
                        <p
                          style={{
                            color: "#222222",
                            fontWeight: "bold",
                            wordBreak: "break-word",
                          }}
                        >
                          {`${item.title}`}
                        </p>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={2}
                      style={{
                        paddingTop: "6px",
                        lineHeight: "19px",
                      }}
                    >
                      <span
                        style={{
                          wordBreak: "break-word",
                          fontSize: "14px",
                          lineHeight: "19px",
                        }}
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      >
                        {/* {`${item.description}`} */}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderSections = () => {
    let sections = []
    let resource1 = {}
    let resource2 = {}
    let resource3 = {}
    if (StaticConfig.Context.UserType === PATIENT) {
      const patient_resourceItems = this.state.content.patient;
      if(patient_resourceItems.length >= 1) {
      resource1.sectionIndex = 0
      resource1.sectionTitle = this.state.content.patientRecourceTitle.ResourcesColumnTitle1
      resource1.sectionImg = imgProductInfo
      resource1.items = patient_resourceItems.filter(i => i.sectionCode === '4:MedStorage')
      resource2.sectionIndex = 1
      resource2.sectionTitle = this.state.content.patientRecourceTitle.ResourcesColumnTitle2
      resource2.sectionImg = imgClinicalTrialInfo
      resource2.items = patient_resourceItems.filter(i => i.sectionCode === '5:ClinTrial')
      resource3.sectionIndex = 2
      resource3.sectionTitle = this.state.content.patientRecourceTitle.ResourcesColumnTitle3
      resource3.sectionImg = imgDiseaseStateInfo
      resource3.items = patient_resourceItems.filter(i => i.sectionCode === '6:PatientInfo')
    }
    } else {
      const resourceItems = this.state.content.hcp;
      if(resourceItems.length >= 1) {
      resource1.sectionIndex = 0
      resource1.sectionTitle = this.state.content.hcpRecourceTitle.ResourcesColumnTitle1
      resource1.sectionImg = imgProductInfo
      resource1.items = resourceItems.filter(i => i.sectionCode === '1:ProdInfo')
      resource2.sectionIndex = 1
      resource2.sectionTitle = this.state.content.hcpRecourceTitle.ResourcesColumnTitle2
      resource2.sectionImg = imgClinicalTrialInfo
      resource2.items = resourceItems.filter(i => i.sectionCode === '2:ClinicalTrial')
      resource3.sectionIndex = 2
      resource3.sectionTitle = this.state.content.hcpRecourceTitle.ResourcesColumnTitle3
      resource3.sectionImg = imgDiseaseStateInfo
      resource3.items = resourceItems.filter(i => i.sectionCode === '3:DiseaseState')
      }
    }
    sections.push(resource1)
    sections.push(resource2)
    sections.push(resource3)
    return (
      <div className='row pl-2'>
        <div
          className='col-lg-4'
          style={{ paddingTop: (isMobileDevice() ? '5px' : '') }}
        >
          {this.renderSection(sections[0].sectionIndex, sections[0].sectionTitle,
            sections[0].sectionImg,
            sections[0].items)}
        </div>
        <div className='col-lg-4'>
          {this.renderSection(sections[1].sectionIndex, sections[1].sectionTitle,
            sections[1].sectionImg,
            sections[1].items)}
        </div>
        <div className='col-lg-4'>
          {this.renderSection(sections[2].sectionIndex, sections[2].sectionTitle,
            sections[2].sectionImg,
            sections[2].items)}
        </div>
      </div>)
  }

  render () {
    const formTitle = this.pageTitle;
    const jsx =
      (isMobileDevice()
        ? (
          <div className='page-container'>
            <div className='page-content'>
              <div
                className='jumbotron'
                style={{
                  color: '#fff',
                  background: `linear-gradient(rgba(17, 42, 65, 0.60), rgba(17, 42, 65, 0.60)), url(${imgMainMobile})`,
                  backgroundPosition: 'center',
                  marginBottom: '0 !important',
                  padding: '2rem 1rem 1rem',
                  backgroundSize: 'cover',
                  height: '210px',
                  paddingTop: '80px'
                }}
              >
                <div className='row'>
                  <div
                    className='container'
                    style={{ textAlign: 'center', fontFamily: 'Open Sans', marginTop: '8px' }}
                  >
                    <span
                      className='mb-3 mt-2 text-center'
                      style={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        lineHeight: '27px',
                        color: 'white'
                      }}
                    >{formTitle}
                    </span>
                  </div>
                </div>
              </div>
              <div className='col-xl-12'>
                <RingLoader color='#071d49' loading={this.state.searching} />
              </div>
              {this.renderSections()}
              <div style={{ paddingTop: '250px' }}>&nbsp;</div>
            </div>
            <Footer />
          </div>
        )
        : (
          <div className='page-container'>
            <div className='page-content'>
              <div className='container'>
                <div className='col-xl-12' style={{ paddingLeft: '0px' }}>
                  <h3 className='mb-2 mt-2 search-title'>
                    {formTitle}
                  </h3>
                </div>
                <div className='col-xl-12'>
                  <div className='row'>
                    <div className='col-lg-10'>
                      <p
                        className='text-left subtitle'
                      />
                    </div>
                  </div>
                </div>
                <div className='col-xl-12'>
                  <RingLoader color='#071d49' loading={this.state.searching} />
                </div>
                {this.renderSections()}
              </div>
            </div>
            <Footer />
          </div>)
      )

    return this.countriesMatched() ? jsx : null
  }
}

function mapStateToProps (state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent,
    permissions: state.permissions
  }
}

export default connect(
  mapStateToProps,
  { notify }
)(SiteResources)



// WEBPACK FOOTER //
// ./src/mi-app/siteResources/SiteResources.js